import React from 'react';
import { findMatch, firstSelected } from '@/utils/resultsHelper';
import FormValidationError from '@/components/errors/FormValidationError';
import { updateActiveDatasetConditionContext } from '../actions';

const DatasetConditionContainer = ({
  children,
  error,
  htmlFor,
  labelId,
}) => {
  if (labelId) {
    return (
      <FormValidationError error={error} htmlFor={htmlFor} labelId={labelId}>
        {children}
      </FormValidationError>
    );
  }
  return (
    <>
      {children}
    </>
  );
};

export const mapStateToProps = ({
  datasetConditions: {
    activeCondition,
    attachments: {
      downloadsInProgress,
    },
  },
}) => ({
  category: activeCondition.category,
  code: activeCondition.code,
  datasetCondition: firstSelected(activeCondition.items),
  isDownloading: !!findMatch(downloadsInProgress, firstSelected(activeCondition.items)?.id, 'id'),
  saveErrors: activeCondition.saveErrors,
  saveStatus: activeCondition.saveStatus,
});

export const mapDispatchToProps = {
  updateProperties: updateActiveDatasetConditionContext,
};

export default DatasetConditionContainer;
